"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _objectWithoutProperties = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconUserPlus = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _icon = require("./components/icon.style");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.string,
  color: _propTypes.string
} : {};
var defaultProps = {
  color: '#F00'
};

var Icon = function Icon(_ref) {
  var className = _ref.className,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["className", "color"]);

  return (0, _core.jsx)("div", {
    className: className
  }, (0, _core.jsx)("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), (0, _core.jsx)("defs", null, (0, _core.jsx)("path", {
    d: "M24,26 C26.7614237,26 29,28.2385763 29,31 L29,33 C29,33.5522847 28.5522847,34 28,34 C27.4477153,34 27,33.5522847 27,33 L27,31 C27,29.3431458 25.6568542,28 24,28 L17,28 C15.3431458,28 14,29.3431458 14,31 L14,33 C14,33.5522847 13.5522847,34 13,34 C12.4477153,34 12,33.5522847 12,33 L12,31 C12,28.2385763 14.2385763,26 17,26 L24,26 Z M32,19 C32.5522847,19 33,19.4477153 33,20 L33,22 L35,22 C35.5522847,22 36,22.4477153 36,23 C36,23.5522847 35.5522847,24 35,24 L33,24 L33,26 C33,26.5522847 32.5522847,27 32,27 C31.4477153,27 31,26.5522847 31,26 L31,24 L29,24 C28.4477153,24 28,23.5522847 28,23 C28,22.4477153 28.4477153,22 29,22 L31,22 L31,20 C31,19.4477153 31.4477153,19 32,19 Z M20.5,14 C23.2614237,14 25.5,16.2385763 25.5,19 C25.5,21.7614237 23.2614237,24 20.5,24 C17.7385763,24 15.5,21.7614237 15.5,19 C15.5,16.2385763 17.7385763,14 20.5,14 Z M20.5,16 C18.8431458,16 17.5,17.3431458 17.5,19 C17.5,20.6568542 18.8431458,22 20.5,22 C22.1568542,22 23.5,20.6568542 23.5,19 C23.5,17.3431458 22.1568542,16 20.5,16 Z",
    id: "path-1"
  })), (0, _core.jsx)("g", {
    id: "s-icons-/-social-/-user-plus",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("g", {
    id: "colors/color/colorNeutral/colorNeutral07"
  }, (0, _core.jsx)("g", {
    id: "protection-area-/-system-icon"
  }, (0, _core.jsx)("rect", {
    x: "0",
    y: "0",
    width: "48",
    height: "48"
  })), (0, _core.jsx)("use", {
    id: "Mask",
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
};

process.env.NODE_ENV !== "production" ? Icon.propTypes = propTypes : void 0;
Icon.defaultProps = defaultProps;
var IconUserPlus = (0, _stylitas.styled)(Icon)(_templateObject(), _icon.iconBase);
exports.IconUserPlus = IconUserPlus;
IconUserPlus.displayname = 'IconUserPlus';